import { useQuery } from '@apollo/client';
import { GET_REPORT_TEMPLATES_QUERY } from '../operations';

export const useGetReportTemplates = () => {
  const { data, loading, error } = useQuery(GET_REPORT_TEMPLATES_QUERY);

  return {
    templates: data?.smartReportTemplates?.templates || [],
    totalCount: data?.smartReportTemplates?.totalCount || 0,
    loading,
    error,
  };
};
